import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { DatabaseManagerProvider } from '../storage-manager/database-manager';
import { UnzipSuggestions } from "./suggestions/UnzipSuggestions.class"

import { UnzipItemData } from './item/UnzipItemData.class';
/*
  Generated class for the ArchiveManagerProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ArchiveManagerProvider {
  public databaseMgr: DatabaseManagerProvider;
  unzipSuggestions: UnzipSuggestions;
  unzipItemData: UnzipItemData;
  constructor(
    public httpClient: HttpClient,
    public injector: Injector) {
    this.databaseMgr = injector.get(DatabaseManagerProvider);
    this.unzipSuggestions = new UnzipSuggestions(this);
    this.unzipItemData = new UnzipItemData(this);
    // this.initSuggestions();
  }
  readAsText(fileAddress) {
    return this.httpClient.get(fileAddress);
  }



}
